export type MockStates = Record<string, unknown>;

export const MOCK_USER_STATES: MockStates = {
  gen2HomePage: '1',
  leftNavGen2: '1',
  newAAGconfig: '1',
  headerMenu: { ecmDateFormat: 'MMM dd, yyyy' },
  // messages: {}, // This is needed to take care
};

export const MOCK_PROFILE_STATES: MockStates = {
  helpDetails: {
    isHelpEnabled: '1',
  },
};

let originalIntersectionObserver: typeof window.IntersectionObserver;

export const setupMockIntersectionObserver = () => {
  beforeAll(() => {
    originalIntersectionObserver = window.IntersectionObserver;

    class MockIntersectionObserver implements IntersectionObserver {
      private callback: IntersectionObserverCallback;

      private elements: Element[] = [];

      root: Element | Document | null = null;

      rootMargin = '0px';

      thresholds: readonly number[] = [];

      constructor(callback: IntersectionObserverCallback) {
        this.callback = callback;
      }

      observe(element: Element): void {
        this.elements.push(element);
      }

      unobserve(element: Element): void {
        this.elements = this.elements.filter((el) => el !== element);
      }

      disconnect(): void {
        this.elements = [];
      }

      // eslint-disable-next-line class-methods-use-this
      takeRecords(): IntersectionObserverEntry[] {
        return [];
      }

      trigger(entries: IntersectionObserverEntry[]): void {
        this.callback(entries, this);
      }
    }

    window.IntersectionObserver =
      MockIntersectionObserver as unknown as typeof window.IntersectionObserver;
  });

  afterAll(() => {
    window.IntersectionObserver = originalIntersectionObserver;
  });
};

export const setupMockResizeObserver = () => {
  beforeAll(() => {
    const mockResizeObserver = jest.fn().mockImplementation(() => ({
      observe: jest.fn(),
      unobserve: jest.fn(),
      disconnect: jest.fn(),
    }));

    global.ResizeObserver = mockResizeObserver;
  });

  afterAll(() => {
    global.ResizeObserver = undefined as unknown as typeof ResizeObserver;
  });
};
